import React, { useState } from "react";
import Modal from "react-modal";
// import SVG from 'react-inlinesvg';
// import classNames from 'classnames';
import { FormInput } from "tsi-common-react/src/forms/FormInput/index";
import {
    FORM_FIELD_CLASS_NAME,
    FORM_FIELD_REQUIRED_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import surveyModalStyles from "../../../styles/composable/survey-modal.module.scss";

interface IProps {
    isOpen: boolean;
    isSubmitting: boolean;
    onClose: () => void;
    onSubmit: (data: { recipient: string }) => void;
}

export const SurveyModalEmailResults = (props: IProps): React.ReactNode => {
    const [recipient, setRecipient] = useState("");

    const onRecipientChange = (e: React.FormEvent<HTMLInputElement>) => {
        setRecipient(e.currentTarget.value);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        props.onSubmit({
            recipient,
        });
    };

    return (
        <Modal
            aria={{
                modal: true,
                labelledby: "modal-title",
            }}
            style={{
                content: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxHeight: "95%",
                    maxWidth: "542px",
                    width: "96%",
                    overflow: "auto",
                    padding: "40px",
                },
            }}
            // TODO(i18n): Translate contentLabel attribute with t tagged template: contentLabel={t`Survey`}
            contentLabel="Survey"
            portalClassName="locator"
            className="locations store-locator-survey modal"
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            role="dialog"
        >
            <div className={surveyModalStyles.surveyModalInner}>
                <button
                    aria-label={t`Close`}
                    className={concatClassNames([
                        surveyModalStyles.surveyModalClose,
                        "pdp-modal__close",
                    ])}
                    onClick={props.onClose}
                >
                    <div
                        className={surveyModalStyles.surveyModalCloseIcon}
                    ></div>
                </button>
                <div className="send__content survey__carousel">
                    <h1 id="modal-title">{t`Nearest retail locations`}</h1>
                    <p className={surveyModalStyles.surveyModalIntro}>
                        {t`Send the nearest retailer locations straight to your email and access them from your phone.`}
                    </p>
                    <form onSubmit={onSubmit}>
                        <div
                            className={concatClassNames([
                                FORM_FIELD_CLASS_NAME,
                                FORM_FIELD_REQUIRED_CLASS_NAME,
                                "form__field--email",
                            ])}
                        >
                            <FormInput
                                required={true}
                                placeholder={t`Enter your email address`}
                                type="email"
                                value={recipient}
                                onChange={onRecipientChange}
                                disabled={props.isSubmitting}
                                id="email"
                                name="email"
                                autoComplete="email"
                            />
                        </div>
                        <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                            <input
                                type="submit"
                                value={t`Send Results`}
                                className="button"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};
